import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {AccountsReceivableApiService} from './accountsreceivable-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    AccountsReceivableApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkAccountsReceivableModule { }
